import { BCMSCurrency, DisabledPrompt } from "@bcm-dev/bcms-vite";
import { useActivityPageContext } from "compid/pages/ActivityPage";
import React from "react";

import ButtonContainer from 'compid/shared/containers/ButtonContainer';
import WidgetContainer from "compid/shared/containers/WidgetContainer";
import WidgetHeaderView from "compid/shared/containers/WidgetContainer/views/WidgetHeaderView";
import BillerView from "compid/shared/views/BillerView";
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";
import { SVGAsset } from 'res';
/**
 * @function ActivityViewOnlyRecurring 
 * @param {OBJECT} props - Default React.Components props OBJECT
 * @returns {React.Component}
 * @exported true
 * @description Component to show all payments that are pending
 * @example
 * <ActivityViewOnlyRecurring />
 */
export default function ActivityViewOnlyRecurring(props) {
    // Get the state from the page context, check if the set state is an instanceof a biller
    const { filtered } = useActivityPageContext();
    const payments = filtered.filter(payment => payment.status.toLowerCase() === "processing" || payment.status.toLowerCase() === "pending", []);
    // Map over all payments and create a BillerView for each
    const paymentItems = payments.map(payment => {
        return (
            <BillerView
                key={ "payment_" + payment.id }
                biller={ payment.to }
                recurring={ <SVGAsset id="AutoPayIcon" className="blue-icon" /> }
                dataPoint={ `Activity_Processing_Biller_${ payment.id }` }
                paymentInfo={
                    <BillerPaymentView 
                        amount={ payment.amount }
                        status={ payment.status }
                        date={ payment.formatDate }
                        showAutopay={ payment.hasRelatedAutopay } />
                }
                buttons={
                    <ButtonContainer className="set-width">
                        <DisabledPrompt>
                            <SVGAsset id="RightChevronIcon" className="mobile-chevron clickable" data-point={ `Activity_Processing_Chevron_${ payment.to }` } />
                        </DisabledPrompt>
                    </ButtonContainer>
                } />
        );
    }, []);
    // Calculate the total amount of all payments
    const totalAmount = payments.reduce((result, payment) => result + parseFloat(payment.amount.amount), 0);
    // If there are no payment items then this widget should not be rendered
    const shouldShowNoBills = paymentItems.length === 0;

    return (
        <WidgetContainer>
            {/*<StickyWidgetHeaderView>*/}
                <WidgetHeaderView title={
                    <div className="flex-container flex-horizontal align-center">
                       <span data-point="Activity_Processing_Title">Processing</span> 
                        <SVGAsset id="InfoIcon" className="right-icon header-icon" />
                    </div>
               } dataPoint="Activity_Processing_Header">
                    <p className="gray-text">Total: { BCMSCurrency.toCurrency(totalAmount) }</p>
                </WidgetHeaderView>
            {/*</StickyWidgetHeaderView>*/}

            { !shouldShowNoBills ? paymentItems : <ViewOnlyNoBillsView /> }
        </WidgetContainer>
    );
}

function ViewOnlyNoBillsView(props) {
    return (
        <div className="row-container">
            <div className="flex-container flex-horizontal align-center row-main-content">
                <SVGAsset id="UpsellIcon" className="show-on-desktop blue-icon logo set-width logo-container" />
                <SVGAsset id="UpsellIcon" className="logo set-width logo-container show-on-mobile" />

                <div className="flex-width">
                    <span>No processing bills found</span>
                </div>
            </div>
        </div>
    );
}